import { apiGet, apiPost, apiCall } from './apiUtils';

/**
 * Admin Staff Service for React Website
 * Handles admin staff operations
 */

const adminStaffService = {
  /**
   * Get all staff status
   * @returns {Promise<Object>} Staff status data
   */
  getAllStaffStatus: async () => {
    try {
      console.log('👥 Fetching all staff status');
      const response = await apiGet('admin/staff/status', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Staff status response:', response);
      return response;
    } catch (error) {
      console.error('Error fetching staff status:', error);
      // Return fallback data for now
      return {
        success: true,
        data: []
      };
    }
  },

  /**
   * Update staff status
   * @param {number} staffId - Staff ID
   * @param {string} status - New status
   * @returns {Promise<Object>} Update response
   */
  updateStaffStatus: async (staffId, status) => {
    try {
      console.log('🔄 Updating staff status:', staffId, status);
      const response = await apiPost(`admin/staff/${staffId}/status`, {
        status: status
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('Update staff status response:', response);
      return response;
    } catch (error) {
      console.error('Error updating staff status:', error);
      throw error;
    }
  },

  // matches app: api.post('/api/admin/staff/online', staffId ? { staffId } : {})
  goOnline: async (staffId) => {
    return await apiPost('admin/staff/online', staffId ? { staffId } : {});
  },

  // matches app: api.post('/api/admin/staff/offline', staffId ? { staffId } : {})
  goOffline: async (staffId) => {
    return await apiPost('admin/staff/offline', staffId ? { staffId } : {});
  },

  /**
   * End a chat conversation
   * @param {string|number} conversationId - Conversation ID to end
   * @returns {Promise<Object>} Response
   */
  endChat: async (conversationId) => {
    try {
      console.log('🔚 Ending chat conversation:', conversationId);
      const response = await apiPost('admin/chats/end', {
        conversation_id: conversationId
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('End chat response:', response);
      return response;
    } catch (error) {
      console.error('Error ending chat:', error);
      throw error;
    }
  },

  claimChat: async (conversationId) => {
    return await apiPost('admin/chats/claim', { conversation_id: conversationId });
  },

  getActivityLogs: async (params = {}) => {
    try {
      const response = await apiGet('admin/staff/activity-logs', params);
      return response;
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      return { success: false, error: error.message };
    }
  }
};

export default adminStaffService;